/* Płynne rozwijanie grup filtrów w szufladach Modele 3D i Tekstury.
   Natywny <details> przełącza się skokowo, więc na czas zwijania trzymamy go
   otwartego (klasa is-closing) i animujemy wysokość treści razem z jej odstępami.
   Obrót strzałki robi CSS - tutaj tylko stan. */
(() => {
  const GROUPS = '.textures-filters-drawer details.details, .models-filters-drawer details.details';
  const DURATION = 280;
  const EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';
  const running = new WeakMap();

  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function slide(details, opening) {
    const content = details.querySelector('.details__content');
    if (!content) {
      details.open = opening;
      return;
    }

    const previous = running.get(details);
    if (previous) previous.cancel();

    // Wysokość liczona z ramką, żeby odstępy wewnętrzne zwijały się razem z treścią.
    content.style.boxSizing = 'border-box';
    content.style.overflow = 'hidden';
    const full = content.getBoundingClientRect().height;

    const animation = content.animate(
      [
        { height: `${opening ? 0 : full}px`, opacity: opening ? 0 : 1 },
        { height: `${opening ? full : 0}px`, opacity: opening ? 1 : 0 },
      ],
      { duration: DURATION, easing: EASING }
    );

    running.set(details, animation);

    const cleanup = () => {
      running.delete(details);
      content.style.boxSizing = '';
      content.style.overflow = '';
      content.style.height = '';
    };

    animation.addEventListener('finish', () => {
      cleanup();
      if (!opening) {
        details.open = false;
        details.classList.remove('is-closing');
      }
    });

    animation.addEventListener('cancel', () => {
      cleanup();
      details.classList.remove('is-closing');
    });
  }

  // Faza przechwytywania: klik w szufladzie nie dociera do dokumentu w fazie bąbelkowania
  // (obsluga szuflady zatrzymuje propagacje), a przechwytywanie biegnie od dokumentu w dol.
  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const summary = target.closest('.details__summary');
    if (!summary) return;

    const details = summary.closest('details');
    if (!details || !details.matches(GROUPS)) return;
    if (reducedMotion()) return;

    event.preventDefault();

    if (details.open && !details.classList.contains('is-closing')) {
      details.classList.add('is-closing');
      slide(details, false);
    } else if (!details.open) {
      details.open = true;
      slide(details, true);
    }
  }, true);
})();
